export enum LockState {
    LockedArrest = 10,
    UnlockedArrest = 11,
    InTransition = 20
}